module.exports = __webpack_public_path__ + "img/write-notes-from-laptop.f110dc65.jpg";